var ServiceEntryStatus = {
    None: 0,
    Created: 1,
    InProgress: 2,
    Closed: 3,
    getKeyByValue: function (value) {
        var _this = this;
        return Object.keys(this).find(function (key) {
            return _this[key] === value;
        });
    }
};
export default ServiceEntryStatus;
